const NavigationMode = {
	Auto: "Auto",
	Vertical: "Vertical",
	Horizontal: "Horizontal",
	Paging: "Paging",
};
export default NavigationMode;
